import { GetterTree } from 'vuex'
import { IRtrUserState } from './state'

const getters: GetterTree<IRtrUserState, IRtrUserState> = {
  phoneNumber: ({ rtrUser: { phoneNumber } }) => phoneNumber,
}

export default getters
